export default "__VITE_ASSET__BSGQTiCk__"